import './ReferralCodesPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';
import InfiniteScroll from 'react-infinite-scroller';

import { getReferralCodes, putReferralCode, setReferralCode } from "./store/actions";

import Button from 'components/Button';
import LoadingCircle from 'components/LoadingCircle';
import PageContent from 'components/PageContent';
import Textbox from 'components/Textbox';
import FormRow from 'components/FormRow';
import Form from "../../components/Form";
import Label from 'components/Label';

class ReferralCodesPage extends React.Component {
    constructor() {
        super();

        this.columns = [
            {
                text: 'Referral Code',
                name: 'code'
            }, {
                text: 'Count',
                name: 'signupCount'
            }
        ];

        this.state = {
            atEnd: true,
            isInfiniteScrolling: false
        };
    }

    componentDidMount() {
        document.body.classList.add('referral-codes-page');

        this.props.getReferralCodes()
            .then((res) => {
                this.setState({atEnd: res.data.length === 0})
            })
    }

    componentWillUnmount() {
        document.body.classList.remove('referral-codes-page');
    }

    handleChange(event) {
        let newCodeObj = update(this.props.referralCodes.referralCode, {});
        newCodeObj.code = event.target.value;
        console.log('here', newCodeObj);
        this.props.setReferralCode(newCodeObj);
    }

    handleCheckboxChange(code) {
        let newCodeObj = update(code, {});
        newCodeObj.active = !code.active;
        console.log('here', newCodeObj);
        this.props.setReferralCode(newCodeObj);
        this.handleSave();
    };

    async handleInfiniteScroll() {
        if(this.props.referralCodes.isFetching || this.state.isInfiniteScrolling || this.state.atEnd) {
            return;
        }

        try {
            this.setState({isInfiniteScrolling: true});
            let res = await this.props.getReferralCodes(true);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: res.data.length === 0
            });
        } catch(err) {
            console.log('ReferralCodesPage handleInfiniteScroll err', err);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: true
            });
        }
    };

    handleSave = () => {
        return this.props.putReferralCode()
            .then((res) => {
                if(res.code === 200) {
                    this.setState({showConfirmModal: true, showEditModal: false});
                }
            })
    };

    render() {
        const { all, isFetching, isSaving, referralCode } = this.props.referralCodes;
        return (
            <PageContent>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.handleInfiniteScroll.bind(this)}
                    hasMore={!this.state.atEnd}
                >
                    <div className="referral-codes">
                        <Form>
                            <FormRow className="referral-codes__form-row">
                                <Textbox
                                    id="txtReferralCode"
                                    name="viewUrl"
                                    onChange={(event) => this.handleChange(event)}
                                    placeholder="New Referral Code"
                                    required
                                    type="text"
                                    value={referralCode.code || ''}
                                />

                                <Button
                                    disabled={!referralCode || Object.keys(referralCode).length === 0 || isSaving || isFetching}
                                    onClick={this.handleSave}
                                    type="submit"
                                >
                                    Save
                                    {isSaving === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                                </Button>
                            </FormRow>
                        </Form>

                        {isFetching === true ? (
                            <LoadingCircle />
                        ) : (
                            <div className="prices__list--wrapper">
                                <table className="prices-table">
                                    <thead>
                                    <tr>
                                        {this.columns.map((col, index) => {
                                            return (
                                                <th className="users-table__heading"
                                                    key={index}>
                                                    {col.text}
                                                </th>
                                            )
                                        })}
                                        <th className="users-table__heading">
                                            Actions
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {all.map((code) => {
                                            return (
                                                <tr key={code.code}>
                                                    {this.columns.map((col, index) => (
                                                        <td key={index}>
                                                            <div className={`col-${col.name}`}>
                                                                {code[col.name]}
                                                            </div>
                                                        </td>
                                                    ))}

                                                    <td>
                                                        {/*<Button
                                                            noStyles
                                                            onClick={() => this.props.setReferralCode(clone(code))}
                                                        >
                                                            Edit
                                                        </Button>*/}

                                                        <div className="ad-edit-modal__checkbox-wrapper">
                                                            <input
                                                                type="checkbox"
                                                                checked={code.active}
                                                                onChange={() => this.handleCheckboxChange(code)}
                                                                id="chkActive"
                                                            />
                                                            <Label htmlFor="chkActive">Active</Label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </InfiniteScroll>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        referralCodes: state.referralCodes
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getReferralCodes: (isUpdate) => dispatch(getReferralCodes(isUpdate)),
        putReferralCode: () => dispatch(putReferralCode()),
        setReferralCode: (referralCodeObj) => dispatch(setReferralCode(referralCodeObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralCodesPage);



// WEBPACK FOOTER //
// ./src/containers/ReferralCodesPage/index.js